'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unparagraph = exports.paragraph = exports.cleanup = exports.depress = exports.SafeScript = exports.WrappedIFrame = exports.Image = exports.ScaledImage = exports.strip = exports.decode = exports.encode = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /** @jsx adapter.createNode */


exports.Anchor = Anchor;
exports.SandboxedIFrame = SandboxedIFrame;

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

var _picoDom = require('@raywhite/pico-dom');

var _string_utilities = require('./string_utilities');

var _ref_utilities = require('./ref_utilities');

var _node_utilities = require('./node_utilities');

var _attribute_utilities = require('./attribute_utilities');

var _tag_utilities = require('./tag_utilities');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * These are just proxies to the `he` methods.
 * SEE: `https://github.com/mathiasbynens/he`
 */
exports.encode = _string_utilities.encode;
exports.decode = _string_utilities.decode;

// Just closes over the related private methods and compostion.

var strip = exports.strip = function () {
  // eslint-disable-line import/prefer-default-export
  /**
   * Check the content of the node, if it's a text node,
   * just append the content, unless the parent is dangerous.
   * also take note of the fact that block level elements
   * should have spaces added on either side of them so
   * that we aren't merging words, any errors this produces
   * are cleaned up afterwords. Note that spaces also need
   * to be added in place of break tags.
   *
   * @param {String} - the previous value
   *
   * @returns {String} - the next value
   */
  function fn(p, node) {
    if (_picoDom.adapter.isTextNode(node)) {
      var tagName = '';
      var content = _picoDom.adapter.getTextNodeContent(node);
      var parentNode = _picoDom.adapter.getParentNode(node);
      if (_picoDom.adapter.isElementNode(parentNode)) tagName = _picoDom.adapter.getTagName(parentNode);

      // Don't include text from dangerous tags.
      if ((0, _tag_utilities.isDangerousElement)(tagName)) return p;

      // If the parent is block level, pad it.
      return (0, _tag_utilities.isBlockElement)(tagName) || !tagName ? '' + (0, _string_utilities.untrim)(content) + p : '' + content + p;
    }

    // Break should be replaced with spaces.
    if (_picoDom.adapter.isElementNode(node) && _picoDom.adapter.getTagName(node) === 'br') {
      return ' ' + p;
    }

    return p;
  }

  // Partially applied reducer in sequence with `trim`.
  var composed = (0, _picoDom.sequence)(_picoDom.parse, _picoDom.reduce.bind(null, fn, ''), _string_utilities.trim);

  /**
   * Strips the string of any tags while applying logical
   * spacing between inner text nodes. Optionally decodes
   * that string.
   *
   * SEE: `https://github.com/raywhite/office-sites/issues/1097`.
   *
   * @param {String}
   * @param {Boolean}
   *
   * @returns {String}
   */
  return function () {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var _decode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (_decode) return (0, _string_utilities.decode)(composed(str));
    return (0, _string_utilities.encode)(composed(str));
  };
}();

// TODO: `ScaledImage` needs to support the passing of arbitrary params.

var _ref = function () {
  var GIF_REGEX = /\.gif$/;
  var S3_REGEX = /https?:\/\/rw-media.s3.amazonaws.com/;
  var CDN_URL_PREFIX = 'https://cdn1.ep.dynamics.net/s3/rw-media';
  var DEFAULT_RESIZE_PARAMS = 'format=jpg&quality=90&scale=down';
  var DEFAULT_SRCSET_WIDTHS = [1024, 768, 384];

  /**
   * Creates the params needed for a resize responsive image.
   *
   * @param {String}
   * @param {Number}
   *
   * @returns {Object}
   */
  var createSources = function createSources(src, width) {
    // TODO: I'm sure that these sources can be calcutated more efficiently (`.reduce`)
    var SOURCES = [width].concat(DEFAULT_SRCSET_WIDTHS).filter(function (w) {
      return w <= width;
    }).map(function (w) {
      return [src + '?' + DEFAULT_RESIZE_PARAMS + '&width=' + w, w];
    });

    return {
      src: SOURCES[0][0],
      srcset: SOURCES.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            s = _ref4[0],
            d = _ref4[1];

        return s + ' ' + d + 'w';
      }).join(', '),
      sizes: '(min-width: ' + width + 'px) ' + width + 'px, 100vw' // QUESTION: Why... no bueno?
    };
  };

  return [
  /**
   * An image component that uses the width attribute to generate
   * an applicable srcset where presemnt.
   *
   * @param {Object} props
   *
   * @returns {Object} node
   * @private
   */
  function (props) {
    var src = props.src,
        width = props.width,
        height = props.height,
        srcset = props.srcset,
        sizes = props.sizes,
        className = props.className;

    // Is the image hosted on s3?

    if (!(0, _ref_utilities.validate)(src)) return null;
    // @NOTE(@elyobo): Image resizer breaks gifs, skip the CDN.
    if (!S3_REGEX.test(src) || GIF_REGEX.test(src)) {
      return _picoDom.adapter.createNode('img', {
        'class': className || undefined,
        src: src,
        width: width,
        height: height,
        srcset: srcset,
        sizes: sizes
      });
    }

    // QUESTION: Is there value in replacing the srcset values here... probs yes.
    var _src = src.replace(S3_REGEX, CDN_URL_PREFIX);
    if (!+width || !width.trim() || !srcset || !srcset.trim()) {
      return _picoDom.adapter.createNode('img', {
        'class': className || undefined,
        src: _src,
        width: width,
        height: height,
        srcset: srcset,
        sizes: sizes
      });
    }

    /**
     * If we've reached here then the image is hosted by us,
     * contains a width attribute and a srcset. So it was
     * intended to be resized.
     *
     * So we can resize the image using the CDN, and create the
     * appropriate srcset.
     */
    return _picoDom.adapter.createNode('img', _extends({ 'class': className || undefined }, createSources(_src, +width)));
  },
  /**
   * A simple image functional image component. Used outside of `depress`,
   * just renders an image given basic properties.
   *
   * @param {Object} props
   *
   * @returns {Object} node
   * @private
   */
  function (props) {
    var src = props.src;
    var width = props.width,
        height = props.height,
        srcset = props.srcset,
        sizes = props.sizes;


    if (!(0, _ref_utilities.validate)(src)) return null;

    // Rewrite S3 URLs to serve images from the CDN instead.
    src = src ? src.replace(S3_REGEX, CDN_URL_PREFIX) : '';

    return _picoDom.adapter.createNode('img', { src: src, width: width, height: height, srcset: srcset, sizes: sizes });
  }];
}(),
    _ref2 = _slicedToArray(_ref, 2),
    ScaledImage = _ref2[0],
    Image = _ref2[1];

/**
 * A simple functional anchor component.
 *
 * TODO: Needs to support the passing of aribitrary attrs.
 *
 * @param {Object} props
 *
 * @returns {Object} node
 * @private
 */


exports.ScaledImage = ScaledImage;
exports.Image = Image;
function Anchor(props) {
  var href = props.href,
      children = props.children;

  var _href = (0, _ref_utilities.normalize)(href);
  var len = children.length;

  if (_href && len) {
    // Hypertext resources.
    if (_href.substring(0, 4) === 'http' && (0, _ref_utilities.isAbsoluteHTTPResource)(_href)) {
      return _picoDom.adapter.createNode(
        'a',
        {
          href: _href,
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        children
      );
    }

    // `mailto`, `tel` or relative HTTP resources.
    return _picoDom.adapter.createNode(
      'a',
      { href: _href },
      children
    );
  }

  // Don't render anchors with no inner text.
  return null;
}

/**
 * A simple functional wrapped iframe container.
 *
 * TODO: Needs to support the passing of arbitray params.
 *
 * @param {Object} props
 *
 * @returns {Object} node
 * @private
 */
var WrappedIFrame = exports.WrappedIFrame = function () {
  var VIDEO_PARAMS = 'allow-scripts allow-same-origin';
  var FORM_PARAMS = VIDEO_PARAMS + ' allow-forms';

  /**
   * NOTE: We are allowing iframes with whatever domain,
   * so long as it's valid, to be rendered - but the
   * sandbox params restrict it's permission brutally if
   * we don't have that domain in the below whitelist.
   */
  var WHITE_LIST = {
    'youtube.com': VIDEO_PARAMS,
    'youtu.be': VIDEO_PARAMS,
    'vimeo.com': VIDEO_PARAMS,
    'player.vimeo.com': VIDEO_PARAMS,
    'theta360.com': VIDEO_PARAMS,
    'drive.google.com': VIDEO_PARAMS,
    'docs.google.com': FORM_PARAMS,
    'form.jotform.co': FORM_PARAMS,
    'creator.zohopublic.com': FORM_PARAMS,
    'maps.google.com': VIDEO_PARAMS,
    'ratemyagent.com.au': 'allow-scripts allow-popups',
    'ratemyagent.com': 'allow-scripts allow-popups',
    'ratemyagent.co.nz': 'allow-scripts allow-popups',
    'e.issuu.com': VIDEO_PARAMS,
    'livestream.com': VIDEO_PARAMS,
    'cdn.flipsnack.com': VIDEO_PARAMS,
    'player.flipsnack.com': VIDEO_PARAMS,
    'view.joomag.com': VIDEO_PARAMS,
    'viewer.joomag.com': VIDEO_PARAMS,
    'gavl.com': FORM_PARAMS,
    'datastudio.google.com': VIDEO_PARAMS,
    'lookerstudio.google.com': VIDEO_PARAMS,
    'propertyrealm.com.au': FORM_PARAMS,
    'tapi.app': VIDEO_PARAMS // NOTE(@elyobo): Not a video, but requires same params
  };

  // <iframe id="ls_embed_1560830508" src="https://livestream.com/accounts/26913485/events/8692901/player?width=640&height=360&enableInfoAndActivity=true&defaultDrawer=&autoPlay=true&mute=false" width="640" height="360" frameborder="0" scrolling="no" allowfullscreen> </iframe>
  return function (props) {
    var src = props.src;

    var _src = (0, _ref_utilities.normalize)(src);

    if (!_src) return null;

    var _url$parse = _url2.default.parse(_src),
        _host = _url$parse.host;

    var host = _host.replace(/^www\./, '');
    var sandboxAttribute = WHITE_LIST[host] || 'allow-scripts';

    // NOTE: `#44`, fixes an iOS Safari bug.
    var stripped = (0, _ref_utilities.stripHypertextProtocols)(src);
    var className = 'iframe_wrapped_' + host.replace(/[.-]/g, '_').replace(/[^a-zA-Z0-9_]/g, '');

    var extras = sandboxAttribute === VIDEO_PARAMS ? { allowfullscreen: 'allowfullscreen' } : {};

    return _picoDom.adapter.createNode(
      'div',
      { 'class': 'iframe_wrap ' + className },
      _picoDom.adapter.createNode('iframe', _extends({
        src: stripped,
        sandbox: sandboxAttribute || ''
      }, extras))
    );
  };
}();

// A wrapper around our script white list.
// TODO: Needs to support the passing of arbitrary attributes.
var SafeScript = exports.SafeScript = function () {
  var WHITE_LIST = ['ratemyagent.com.au', 'ratemyagent.com', 'ratemyagent.co.nz', 'socialeazie.com', 'infogr.am', 'tapi.app', 'auctionslive.com', 'auctionslive.com.au', 'auctionslive.co.nz', 'cdn.wishpond.net', 'embed.acuityscheduling.com', 'dpr.leadplusstaging.com.au', 'dpr.leadplus.com.au', 'birdeye.com', 'getbirdeye.com.au', 'square.site', 'curator.io', 'widget.reviewability.com'];

  // Our matching function for the white list.
  var isWhiteListedDomain = (0, _string_utilities.createHLDomainLookup)(WHITE_LIST);

  /**
   * @param {String}
   *
   * @returns {Boolean}
   * @private
   */
  var hasWhiteListedDomain = function hasWhiteListedDomain() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var normalized = (0, _ref_utilities.normalize)(str);

    var _url$parse2 = _url2.default.parse(normalized),
        host = _url$parse2.host;

    return isWhiteListedDomain(host);
  };

  /**
   * A script component that will only allow whitelist scripts.
   *
   * @param {Object} props
   *
   * @returns {Object} node
   * @private
   */
  return function (props) {
    var attributes = _extends({}, props);
    var src = attributes.src;

    delete attributes.children;

    if (!hasWhiteListedDomain(src)) return null;

    // Add a switch on the `WHITE_LIST`.
    return _picoDom.adapter.createNode('script', attributes);
  };
}();

/**
 * A sandboxed iframe component.
 * SEE: `https://developer.mozilla.org/en/docs/Web/HTML/Element/iframe`
 *
 * TODO: Needs to support the passing of arbitrary attributes.
 *
 * @param {Object} props
 *
 * @returns {Object} node
 * @private
 */
function SandboxedIFrame(props) {
  var src = props.src;

  if (!(0, _ref_utilities.validate)(src)) return null;

  return _picoDom.adapter.createNode(
    'div',
    { 'class': 'iframe_wrap' },
    _picoDom.adapter.createNode('iframe', { src: src })
  );
}

var depress = exports.depress = function () {
  // SEE: office-sites/#1093 @ `https://github.com/raywhite/office-sites/issues/1093`.
  var CLASS_WHITELIST = ['ALIGNLEFT', 'ALIGNRIGHT', 'ALIGNCENTER', 'ALIGNNONE', 'tapi-embedded-request', // required for tapi integration
  'RMA-widget', // required for RW widget integration
  'wishpond-campaign', // required for wishpond widget integration
  'json-ld-content'];

  /**
   * Filters desired classes from element class lists.
   *
   * @param {String}
   *
   * @returns {String}
   */
  var filterClassList = (0, _attribute_utilities.createClassListFilterFn)(CLASS_WHITELIST);

  /**
   * @param {Object}
   *
   * @returns {Object|Array}
   * @private
   */
  function fn(node) {
    var tagName = _picoDom.adapter.getTagName(node);
    var children = _picoDom.adapter.getChildNodes(node);

    // This function only operates on nodes.
    if (_picoDom.adapter.isElementNode(node)) {
      // Remove all dangerous elements.
      if ((0, _tag_utilities.isDangerousElement)(tagName) && tagName !== 'iframe' && tagName !== 'script') return null;

      var _attributes = _picoDom.adapter.getAttrList(node);
      var attributes = (0, _node_utilities.transformAttributes)(_attributes);

      // Allow `colspan` on table elements, see issue #29.
      if (tagName === 'td' || tagName === 'thead') {
        var colspan = parseInt(attributes.colspan, 10);
        if (colspan < 0 || colspan > 1000) colspan = 1;
        (0, _node_utilities.removeUnsafeAttributes)(node, tagName, children);

        if (!colspan) return node;

        _picoDom.adapter.adoptAttributes(node, [{ name: 'colspan', value: String(colspan) }]);

        return node;
      }

      var className = filterClassList(attributes.class || '');

      // Remove empty block level elements unless they have data attributes
      if ((0, _tag_utilities.isBlockElement)(tagName) && tagName !== 'iframe' && !children.length && !(0, _node_utilities.hasDataAttributes)(node) && !attributes.id) return null;

      // Form elements shouldn't be present. Unless they have whitelisted.
      if ((0, _tag_utilities.isFormElement)(tagName)) {
        return attributes.id !== 'br-article-id' || attributes.type !== 'hidden' ? null : function () {
          var newNode = _picoDom.adapter.cloneNode(node);
          (0, _node_utilities.removeUnsafeAttributes)(newNode, tagName, children);
          _picoDom.adapter.adoptAttributes(newNode, [{ name: 'id', value: 'br-article-id' }, { name: 'type', value: 'hidden' }]);

          return newNode;
        }();
      }

      // Use the image component for images.
      if (tagName === 'img') {
        return _picoDom.adapter.createNode(ScaledImage, _extends({ className: className }, attributes));
      }

      // Use anchor component for anchors.
      if (tagName === 'a') {
        var href = attributes.href;

        return _picoDom.adapter.createNode(
          Anchor,
          { href: href },
          children
        );
      }

      // Add a responsive wrapper to iframes.
      if (tagName === 'iframe') {
        var src = attributes.src;

        return _picoDom.adapter.createNode(WrappedIFrame, { src: src });
      }

      if (tagName === 'script') {
        return _picoDom.adapter.createNode(SafeScript, attributes);
      }

      // Remove any existing wrappers, or flatten nested divs.
      if (tagName === 'div') {
        var len = children.length;
        var firstChild = _picoDom.adapter.getFirstChild(node);
        var _tagName = firstChild && _picoDom.adapter.isElementNode(firstChild) ? _picoDom.adapter.getTagName(firstChild) : '';

        if (len === 1 && _tagName === 'div') return children;
      }

      /**
       * TODO: We should bail quickly if there is no style, otherwise this
       * is a pretty expensive operation for each node making it through to
       * here.
       *
       * Extract the `text-align` property from an inline style.
       */
      var align = (0, _attribute_utilities.extractInlineStyleText)(attributes.style, 'text-align');

      // Remove all attributes from the cloned node.
      (0, _node_utilities.removeUnsafeAttributes)(node, tagName, children);

      // Apply text alignment where present - see office-sites issue #1001.
      if (align) _picoDom.adapter.adoptAttributes(node, [{ name: 'style', value: align }]);
      if (className) _picoDom.adapter.adoptAttributes(node, [{ name: 'class', value: className }]);

      // Permit start on ordered lists
      if (attributes.start && tagName === 'ol') {
        var start = parseInt(attributes.start, 10);
        if (start) _picoDom.adapter.adoptAttributes(node, [{ name: 'start', value: String(start) }]);
      }

      return node;
    }

    // Empty text nodes are just removed.
    if (_picoDom.adapter.isTextNode(node)) {
      var content = _picoDom.adapter.getTextNodeContent(node);
      if (!content.trim()) return null;
    }

    // Remove all attributes on remaining nodes.
    (0, _node_utilities.removeUnsafeAttributes)(node, tagName, children);
    return node;
  }

  // Compose `fn` with parse and stringify.
  return (0, _picoDom.sequence)(_picoDom.parse, _picoDom.map.bind(null, fn), _picoDom.stringify);
}();

var cleanup = exports.cleanup = function () {
  /**
   * TODO: Document.
   *
   * @param {Object}
   *
   * @returns {Object|Array}
   * @private
   */
  function fn(node) {
    if (_picoDom.adapter.isElementNode(node)) {
      var tagName = _picoDom.adapter.getTagName(node);
      var children = _picoDom.adapter.getChildNodes(node);

      // Remove any dangerous elements and their contents.
      if ((0, _tag_utilities.isDangerousElement)(tagName)) return null;

      // Replace a tag with it's own children if it's not allowed.
      if (!(0, _tag_utilities.isCleanElement)(tagName)) return children;

      // Remove any elements with no children (unless they are safe and self close).
      if (!children.length && !(0, _tag_utilities.isSelfClosingElement)(tagName)) return null;

      var transformedTagName = (0, _tag_utilities.cleanElementTransform)(tagName);

      // Transform the element if needed, manually use `createNode`.
      if (transformedTagName) return _picoDom.adapter.createNode(transformedTagName, null, children);

      var _attributes = _picoDom.adapter.getAttrList(node);
      var attributes = (0, _node_utilities.transformAttributes)(_attributes);

      // TODO: url validation for anchors and links.
      if (tagName === 'img') {
        var src = attributes.src;

        return _picoDom.adapter.createNode(Image, { src: src });
      }

      // Use anchor component for anchors.
      if (tagName === 'a') {
        var href = attributes.href;

        return _picoDom.adapter.createNode(
          Anchor,
          { href: href },
          children
        );
      }

      // Just remove the attributes and return the node.
      (0, _node_utilities.removeUnsafeAttributes)(node);
      return node;
    }

    // Empty text nodes are just removed. No need to encode.
    if (_picoDom.adapter.isTextNode(node)) {
      var content = _picoDom.adapter.getTextNodeContent(node);
      if (!content.trim()) return null;
    }

    return node;
  }

  /**
   * TODO: Document.
   *
   * @param {Object}
   *
   * @returns {Object|Array}
   * @private
   */
  function denest(node) {
    if (_picoDom.adapter.isElementNode(node)) {
      var tagName = _picoDom.adapter.getTagName(node);
      var children = _picoDom.adapter.getChildNodes(node);

      // Remove nested paragraphs - they are semantically incorrect.
      if (tagName === 'p') {
        var len = children.length;
        for (var i = 0; i < len; i++) {
          var childNode = children[i];

          // If any child node is a paragraph, we need to return children.
          if (_picoDom.adapter.isElementNode(childNode) && _picoDom.adapter.getTagName(childNode) === 'p') {
            return children;
          }
        }
      }
    }

    return node;
  }

  return (0, _picoDom.sequence)(_picoDom.parse, _picoDom.map.bind(null, fn), _picoDom.map.bind(null, denest), _picoDom.stringify);
}();

// The exports remaining to be completed.
var paragraph = exports.paragraph = function () {
  var DOUBLE_DELIMITER = '@@MARKUP:DOUBLE_DELIMITER@@';
  var SINGLE_DELIMITER = '@@MARKUP:SINGLE_DELIMITER@@';

  /**
   * The reducer function used to extract the text nodes,
   * while maintaining some indication of their structure.
   *
   * @param {Array}
   * @param {Object}
   *
   * @returns {Array}
   * @private
   */
  function fn(tokens, node) {
    // Only breaks should be present.
    if (_picoDom.adapter.isElementNode(node)) {
      // Remove any trailing breaks, we have no need for them.
      if (!tokens.length) return tokens;

      var previous = tokens[0];
      // If we've previous encountered a break, then we should reduce to a double.
      if (previous === SINGLE_DELIMITER || previous === DOUBLE_DELIMITER) {
        tokens[0] = DOUBLE_DELIMITER;
        return tokens;
      }

      tokens.unshift(SINGLE_DELIMITER);
      return tokens;
    }

    if (_picoDom.adapter.isTextNode(node)) {
      var content = _picoDom.adapter.getTextNodeContent(node);
      var trimmed = content.trim();
      if (trimmed) tokens.unshift(trimmed);
    }

    return tokens;
  }

  /**
   * Returns an array to be used as the initial value
   * reduction of the AST.
   *
   * @returns {Array}
   * @private
   */
  function init() {
    return [];
  }

  /**
   * Takes the tokens generated by the reduction above and flattens
   * the structure (removes all of the delimiters that were originally
   * present at the beginning of the sequence).
   *
   * @param {Array}
   *
   * @returns {Array}
   * @private
   */
  function flatten(tokens) {
    var del = 0;
    var len = tokens.length;
    for (var i = 0; i < len; i++) {
      var token = tokens[i];
      if (token !== SINGLE_DELIMITER && token !== DOUBLE_DELIMITER) break;
      del++;
    }

    tokens.splice(0, del);
    return tokens;
  }

  /**
   * Removes all tokens that were used to indicate the presence of
   * line breaks and creates a nested strucute (an array of strings,
   * that may contain nested arrays of strings) that is sufficient
   * to encode the required markup structure.
   *
   * @param {Array}
   *
   * @returns {Array}
   * @private
   */
  function nest(tokens) {
    var pending = [];
    var ret = [];
    var len = tokens.length;

    for (var i = 0; i < len; i++) {
      var token = tokens[i];
      // We buffer up all of the tokens except for double delims.
      if (token !== SINGLE_DELIMITER && token !== DOUBLE_DELIMITER) pending.push(token);

      /**
       * When we hit a double delim or the end of the sequence,
       * dump the pending values into the return array.
       */
      if (token === DOUBLE_DELIMITER || i === len - 1) {
        ret.push(pending.length > 1 ? pending : pending[0]);
        pending = [];
      }
    }

    return ret;
  }

  // The possible return values from `isPotentialList`.
  var FLAG_PARAGRAPH = '@@MARKUP/FLAG_PARAGRAPH@@';
  var FLAG_LIST = '@@MARKUP/FLAG_UNORDERED_LIST@@';
  var FLAG_HEADED_LIST = '@@MARKUP/FLAG_UNORDERED_LIST_WITH_HEADING@@';

  // The miminum number of lines that can be interpreted as a list.
  var MIN_LINE_COUNT = 3;

  // The maximum lenth / reguular expression for detecting a heading.
  var MAX_HEADING_LENGTH = 80;
  var HEADING_REGEX = new RegExp('^[^-*\u2022].{1,' + MAX_HEADING_LENGTH + '}[;:]$');

  // The maximun length / regular expression for detecting a list item.
  var MAX_ITEM_LENGTH = 190;
  var LIST_ITEM_REGEX = new RegExp('^[-*\u2022] ?.{1,' + MAX_ITEM_LENGTH + '}$');

  /**
   * Given a set of strings that were originally seperated by
   * single line breaks, this functions is used to determine if
   * that set was intended as a parahtaph, a list, or a list with
   * a heading... it returns a string constant representing one
   * of these.
   *
   * @param {Array}
   *
   * @returns {String}
   */
  function flagPotentialList(lines) {
    var i = 0;
    var len = lines.length;

    // It should have at least `MIN_LINE_COUNT` elements.
    if (len < MIN_LINE_COUNT) return FLAG_PARAGRAPH;

    // The first could potentially be a heading.
    var hasHeading = false;
    if (HEADING_REGEX.test(lines[0])) {
      hasHeading = true;
      i++;
    }

    // Loop through the lines to see if each matches our criteria.
    for (; i < len; i++) {
      if (!LIST_ITEM_REGEX.test(lines[i])) return FLAG_PARAGRAPH;
    }

    return hasHeading ? FLAG_HEADED_LIST : FLAG_LIST;
  }

  /**
   * Creates a list from a set of unmodified strings -
   * the leading dashes etc. are trimmed out.
   *
   * @param {Object}
   *
   * @returns {Object}
   */
  function List(props) {
    // eslint-disable-line no-unused-vars
    var items = props.items;

    return _picoDom.adapter.createNode(
      'ul',
      null,
      items.map(function (i) {
        return _picoDom.adapter.createNode(
          'li',
          null,
          i.substring(1).trim()
        );
      })
    );
  }

  /**
   * A component to generate either paragraphs or lists.
   *
   * @param {Object}
   *
   * @returns {Object}
   */
  function TextBlock(props) {
    // eslint-disable-line no-unused-vars
    var tokens = props.tokens;

    return _picoDom.adapter.createNode(
      'fragment',
      null,
      tokens.map(function (token) {
        // If the item is not an array it's a paragraph.
        if (!Array.isArray(token)) return _picoDom.adapter.createNode(
          'p',
          null,
          token
        );

        // Clone the token (Array) so that we don't mutate.
        var items = [].concat(_toConsumableArray(token));

        // Otherwise we should switch on it's derived type.
        switch (flagPotentialList(items)) {// eslint-disable-line default-case
          case FLAG_PARAGRAPH:
            // eslint-disable-line no-case-declarations
            var stop = items.length - 1;
            return _picoDom.adapter.createNode(
              'p',
              null,
              items.reduce(function (previous, current, index) {
                previous.push(current);
                if (index !== stop) previous.push(_picoDom.adapter.createNode('br', null));

                return previous;
              }, [])
            );

          case FLAG_LIST:
            return _picoDom.adapter.createNode(List, { items: items });

          case FLAG_HEADED_LIST:
            return [_picoDom.adapter.createNode(
              'p',
              null,
              items.shift()
            ), _picoDom.adapter.createNode(List, { items: items })];
        }

        // ESLint made me.
        return null;
      })
    );
  }

  /**
   * Generate a document fragment model containing the
   * the transformed markup structure.
   *
   * @param {Array}
   *
   * @returns {Object}
   * @private
   */
  function generate(tokens) {
    return _picoDom.adapter.createNode(TextBlock, { tokens: tokens });
  }

  // Compose a tokenizer.
  var tokenize = (0, _picoDom.sequence)(_picoDom.reduce.bind(null, fn, init), flatten, nest);

  // Compose the tokenizer and generator.
  var transform = (0, _picoDom.sequence)(tokenize, generate);

  // Boom... composition of compositions, of compositions.
  return (0, _picoDom.sequence)(_picoDom.parse, transform, _picoDom.stringify);
}();

// A version of paragraph that first ungarbles the input.
var unparagraph = exports.unparagraph = (0, _picoDom.sequence)(_string_utilities.ungarble, paragraph);